<template>
  <button type="button" class="mbtn btn-primary">
    <i class="fa-solid fa-plus"></i>
    {{ caption }}
  </button>
</template>
<script>
export default {
  props: {
    caption: {
      type: String,
      default: "Add",
    },
  },
};
</script>
<style scoped>
.fa-circle-plus {
  font-size: 12px;
}
</style>
